import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fullscreen-exit",
  "use": "icon-fullscreen-exit-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fullscreen-exit\">\n  <path d=\"M4 3.5H13V12.5H14V3.5C14 2.94772 13.5523 2.5 13 2.5H4V3.5Z\" fill=\"black\" fill-opacity=\"0.9\" />\n  <path d=\"M2 13.5C2 14.0523 2.44772 14.5 3 14.5L11 14.5C11.5523 14.5 12 14.0523 12 13.5L12 5.5C12 4.94772 11.5523 4.5 11 4.5H3C2.44772 4.5 2 4.94772 2 5.5V13.5ZM3 5.5L11 5.5L11 13.5L3 13.5L3 5.5Z\" fill=\"black\" fill-opacity=\"0.9\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol